module.exports = __webpack_public_path__ + "media/country_flags/py-a8aa2f6e.png";